/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-28 14:45:08
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-28 16:02:43
 * @FilePath: \hlweb2.0\src\pages\Solution\InfoServices\ProductExperience\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

function ProductExperience() {
  const { t } = useTranslation();
  const productExperienceCenter = t("solution_infoServices.infoServices6", {
    returnObjects: true,
  });
  return (
    <div className="productExperience_">
      <div className="edition_solution">
        <div className="edition_solution_title">
          <div>{productExperienceCenter.til}</div>
          <span>{productExperienceCenter.dil}</span>
        </div>
      </div>
      <ul className="productExperience_con">
        {productExperienceCenter.contractList.map((item, index) => {
          return (
            <li key={index}>
              <div className="productExperience_num">{item.num}</div>
              <div className="productExperience_detail">{item.detail}</div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ProductExperience;
